require('@pages/hub/styles.scss');

const React = require('react');
const { View } = require('@pages/hub/view');
const hydrate = require('nordic/hydrate');
const { loadableReady } = require('nordic/lazy');

const props = window.__PRELOADED_STATE__;

loadableReady(() => {
  hydrate(<View {...props} />, document.getElementById('root-app'));
});
